'use client';

import React from 'react';

interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
  language: 'en' | 'ar';
}

const CategoryFilter = ({
  categories,
  activeCategory,
  onCategoryChange,
  language
}: CategoryFilterProps) => {
  const translateCategory = (category: string): string => {
    if (language === 'en') return category;

    const translations: { [key: string]: string } = {
      'All': 'الكل',
      'Moving Process': 'عملية النقل',
      'Pricing & Payments': 'التسعير والدفع',
      'Insurance & Protection': 'التأمين والحماية',
      'Kuwait Regulations': 'لوائح الكويت',
      'Emergency Support': 'الدعم الطارئ'
    };

    return translations[category] || category;
  };

  return (
    <section className="py-8 bg-muted border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap gap-3 justify-center">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-base ${
                activeCategory === category
                  ? 'bg-primary text-primary-foreground shadow-soft'
                  : 'bg-card text-text-primary hover:bg-card-foreground hover:text-card border border-border'
              }`}
            >
              {translateCategory(category)}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryFilter;